import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import ThermometerSegments from '../../thermometer/components/ThermometerSegments';
import { formatNumber } from '../../../common/utils';
import { formatLabel } from '../../utils';
var FrequencyTableRow = function (_a) {
    var pair = _a.pair, totalCount = _a.totalCount, dataType = _a.dataType;
    var thermometerData = [
        { label: '', value: pair.value, severity: 'primary' },
        { label: '', value: totalCount - pair.value },
    ];
    return (React.createElement(TableRow, { className: "frequencyTable__row", key: pair.label },
        React.createElement(TableCell, null, formatLabel(pair.label, dataType)),
        React.createElement(TableCell, { align: 'right' }, formatNumber(pair.value)),
        React.createElement(TableCell, null,
            React.createElement(ThermometerSegments, { valueLabelPairs: thermometerData, tooltipMode: 'first-value' }))));
};
export default FrequencyTableRow;
//# sourceMappingURL=FrequencyTableRow.js.map